// #region Imports
import { inject, Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { Currency } from '../models/Currency';
// #endregion Imports

// #region ComponentDecorator
@Injectable({
  providedIn: 'root',
})
// #endregion ComponentDecorator
export class GeolocationService {
  // #region DependencyInjection
  private readonly appService: AppService = inject(AppService);
  // #endregion DependencyInjection

  // #region PublicMethods
  /** Salva come valuta corrente quella marcata come predefinita nell'elenco già in local storage. */
  setDefaultCurrency(): void {
    const currencies: Currency[] = JSON.parse(
      this.appService.getLocal(this.appService.localCurrencies)
    ) as Currency[];
    const currency: Currency = currencies?.filter((currencyItem: Currency): boolean => currencyItem.Default == true)[0];
    this.appService.setLocal(
      this.appService.localCurrency,
      JSON.stringify(currency)
    );
  }
  // #endregion PublicMethods
}
